import { Button, Typography } from '@eye-able/ui';
import { useEffect } from 'react';
import { useBootScreen } from '@hooks/useBootScreen';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  const { t } = useTranslation();
  const { disableBootScreen } = useBootScreen();

  useEffect(() => {
    disableBootScreen();
  }, [disableBootScreen]);

  return (
    <div className='eye:flex eye:flex-col eye:items-center eye:gap-3xs eye:my-xl eye:text-center'>
      <Typography variant='headline-l'>404</Typography>
      <Typography variant='body-l'>{t('pageNotFound')}</Typography>
      <Button asChild>
        <Link to='/'>{t('backToHome')}</Link>
      </Button>
    </div>
  );
}
